import { TFieldStateArgs } from '../model';

export function shouldUpdateControlState<T = unknown>(
  member: keyof TFieldStateArgs<T>,
  args: Partial<TFieldStateArgs<T>>
): boolean {
  const isMemberInArgs = member in args;

  if (!isMemberInArgs) {
    return false;
  }

  return true;
}
